export default __webpack_public_path__ + "static/cube2-bedfbbc0abecc2804f42abfcee32ba7d.mp4";